var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "text-danger mb-10" }, [
        _vm._v(_vm._s(_vm.errorMsg)),
      ]),
      _vm._v(" "),
      _c(
        "JsonEditorVue",
        _vm._b(
          {
            attrs: { mode: "text" },
            model: {
              value: _vm.myInfo,
              callback: function ($$v) {
                _vm.myInfo = $$v
              },
              expression: "myInfo",
            },
          },
          "JsonEditorVue",
          {
            /* local props & attrs */
          },
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }